import { NumberFormat } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { getCurrentLocale } from '../../../../../../utils'
import { useRecurringInvoice } from '../../contexts/recurringInvoiceContext'

export const RecurringInvoiceTitle = () => {
  const { t } = useTranslation()
  const { recurringInvoice, isLoading } = useRecurringInvoice()

  if (isLoading) {
    return ''
  }

  const { customer, summary } = recurringInvoice?.draft || {}

  const name = customer?.displayName || customer?.companyName || t('recurring_invoices.page.title.default_name')
  const amount =
    summary?.foreignGrossTotal !== undefined
      ? NumberFormat.getCurrencyNumber(summary?.foreignGrossTotal, summary?.foreignCurrency, getCurrentLocale())
      : null

  const title = [name, amount].filter(Boolean).join(' - ')

  return title
}
